import { Compass } from 'lucide-react';
import type { ReactElement } from 'react';
import { Link } from 'react-router';

import { routePaths } from '../app/route-paths.js';
import { PageHeader } from '../components/layout/PageHeader.js';
import { EmptyState } from '../components/ui/EmptyState.js';

export function NotFoundPage(): ReactElement {
    return (
        <>
            <PageHeader title="Page not found" />
            <EmptyState
                icon={Compass}
                title="That page does not exist"
                description="The link may be out of date."
                action={<Link to={routePaths.today}>Go to Today</Link>}
            />
        </>
    );
}
